/**
 * @Author: yxp
 * @Date:   2017-07-11 16:07:97
 * @Last modified by:   yxp
 * @Last modified time: 2017-09-12 11:09:42
 */

import axios from '@/services/axios';

const VerifyReq = '/api/send/verify/';

export default {
  checkPhone(checkReq, params = {}) {
    return axios.get(checkReq, { params }).then(event => event.data.exists);
  },
  checkPhoneV2(checkReq, params = {}) {
    return axios.get(checkReq, { params }).then(event => event.data); // 返回更完整的信息
  },
  checkProtocol(protocolReq, params = {}) {
    return axios.get(protocolReq, { params }).then(event => event.data.has_read_agreement);
  },
  login(loginReq, params = {}, data = {}) {
    return axios.post(loginReq, data, { params }).then(event => event.data);
  },
  reset(resetReq, params = {}, data = {}) {
    return axios.post(resetReq, data, { params }).then(event => event.data);
  },
  register(registerReq, params = {}, data = {}) {
    return axios.post(registerReq, data, { params }).then(event => event.data);
  },
  checkBinding(checkBindingReq, params = {}) {
    return axios.get(checkBindingReq, { params }).then(event => event.data.binding);
  },
  bind(bindReq, params = {}, data = {}) {
    return axios.post(bindReq, data, { params }).then(event => event.data);
  },
  getVerifyCode(params = {}, data = {}) {
    return axios.post(VerifyReq, data, { params }).then(event => event.data.success);
  },
};



// WEBPACK FOOTER //
// ./src/services/login.js